import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    cmsData: {}
};

export const setCmsData = (state = INITIAL_STATE, { data }) => {
    return { ...state, cmsData: data };
};

export const HANDLERS = {
    [Types.SET_CMS_DATA]: setCmsData
};

export default createReducer(INITIAL_STATE, HANDLERS);
